// File: general-template-4.js
// Import Cumulo
import Cumulo from '../modules/cumulo.js';
import tbxHandleExpanders from '../sections/expanders.js';

class GeneralTemplate4Renderer extends Cumulo {
    onEnter() {
    	tbxHandleExpanders();
    }
}

// Don`t forget to export your renderer
export default GeneralTemplate4Renderer;